import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client'
import './index.css'
import {
    BrowserRouter, Navigate, Route, Routes,
} from 'react-router-dom';
import {App as AntdApp, ConfigProvider} from "antd"

import moment from "moment"
import "moment/locale/de"

import LoginPage from "./pages/Login"
import DashboardPage from "./pages/Dashboard"
import LeadsPage from "./pages/Leads"
import UsersPage from "./pages/Users"
import ProposalsPage from "./pages/Proposals"
import ZipCodesPage from "./pages/ZipCodes"
import AllLeadsPage from './pages/AllLeads';
import AllAppointmentsPage from './pages/AllAppointments';
import AllProposalsPage from './pages/AllProposals';

import Cookies from 'js-cookie';
import { SyncLoader } from 'react-spinners';
import deDE from 'antd/locale/de_DE';

moment.locale('de')

const root = ReactDOM.createRoot(document.getElementById('root'))

global.BesserRasen = {
    session: null,
    backendUrl: process.env.NODE_ENV === "development" ? "http://localhost:3000" : "https://backend.kb.besserrasen.de"
}

const NotFoundPage = () => <div style={{
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column"
}}>
    <img src="https://besserrasen.de/img/br_favicon.ico"
         style={{ width: 64, height: 64, marginBottom: 16 }} />
    <h1>Ups!</h1>
    <h2 style={{ fontWeight: 400 }}>Diese Seite konnte leider nicht gefunden werden.</h2>
</div>

const Application = () => {
    const [ validSession, setValidSession ] = useState(null)

    useEffect(() => {
        const sessionCookie = Cookies.get("session")

        if(sessionCookie) {
            const session = JSON.parse(sessionCookie)

            if(session.token) {
                fetch(`${global.BesserRasen.backendUrl}/api/v1/auth/refresh`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${session.token}`
                    }
                }).then(async data => {
                    if(data.status === 200) {
                        const user = await data.json()

                        global.BesserRasen.session = user

                        Cookies.set("session", JSON.stringify(user), { domain: process.env.NODE_ENV === "development" ? "localhost" : "kb.besserrasen.de", expires: 365 })

                        setValidSession(true)
                    } else {
                        Cookies.remove("session")
                        setValidSession(false)
                    }
                }).catch(() => setValidSession(false))
            } else setValidSession(false)
        } else setValidSession(false)
    }, []);

    if(validSession === null) return <div style={{ display: "flex", alignItems: "center", justifyContent: "center", background: "#eee", width: "100vw", height: "100vh" }}>
        <SyncLoader size={24} color="#2d4b00" />
    </div>

    return <ConfigProvider locale={deDE} theme={{
        components: {
            Layout: {
                siderBg: "#1e272e"
            },
            Menu: {
                darkItemBg: "#1e272e",
                darkItemSelectedBg: "#8aa178",
                itemBorderRadius: 4,
                itemMarginInline: 12,
                itemHeight: 48,
                iconSize: 20,
                fontSize: 16
            }
        },
        token: {
            colorPrimary: "#2d4b00"
        }
    }}>
        <AntdApp>
            <BrowserRouter>
                <Routes>
                    {validSession && <>
                        <Route path="/*" element={<NotFoundPage />} />,
                        <Route path="/" element={<DashboardPage />} />
                        <Route path="/leads" element={<LeadsPage />} />
                        <Route path="/proposals" element={<ProposalsPage />} />
                        <Route path="/users" element={<UsersPage />} />
                        <Route path="/zipcodes" element={<ZipCodesPage />} />
                        <Route path="/all-leads" element={<AllLeadsPage />} />
                        <Route path="/all-appointments" element={<AllAppointmentsPage />} />
                        <Route path="/all-proposals" element={<AllProposalsPage />} />
                    </>}
                    {!validSession && <Route path="/*" element={<Navigate to="/login" />} />}
                    <Route path="/login" element={validSession ? <Navigate to="/" /> : <LoginPage />} />
                </Routes>
            </BrowserRouter>
        </AntdApp>
    </ConfigProvider>
}

root.render(<Application />)
